import _ from 'lodash';

const getNonEmptyArray = (arr) => (Array.isArray(arr) ? _.compact(arr) : []);

// Returns the index of the currently selected value, or 0 if not found
export const getSelectedIndex = (options, selected) => {
  const idx = options.findIndex((o) => o.value === selected);
  return idx >= 0 ? idx : 0;
};

export default getNonEmptyArray;
